<div class="main-container">
  <div class="btn-group" *ngIf="!user">
    <goab-button class="sign-in" (onClick)="login()" data-cy="sign-in" type="primary">Sign in</goab-button>
    <div class="btn-description"><p>To continue or view your FSCD application.</p></div>
  </div>
  <div class="btn-group">
    <goab-button
      class="create-app"
      (onClick)="navigateToPage(preScreenPage)"
      data-cy="create-application"
      type="primary"
    >
      Create application</goab-button
    >
    <div class="btn-description">
      <p>To create an FSCD application, or to find out if FSCD is the right program for you.</p>
    </div>
  </div>
</div>
